import React, { useState, useEffect } from "react";
import { getDateOptions, getUrlParams } from "../utils/dateUtils";

const getToday = () => {
  const now = new Date();
  return {
    day: "01",
    month: "01",
    year: now.getFullYear().toString()
  };
};

const today = getToday();

const SearchForm = () => {
  const { days, months, years } = getDateOptions();

  const [selectedDay, setSelectedDay] = useState(today.day);
  const [selectedMonth, setSelectedMonth] = useState(today.month);
  const [selectedYear, setSelectedYear] = useState(today.year);

  useEffect(() => {
    const urlParams = getUrlParams();
    setSelectedDay(urlParams.day || today.day);
    setSelectedMonth(urlParams.month || today.month);
    setSelectedYear(urlParams.year || today.year);
  }, []);

  const searchGoldPriceHistory = () => {
    const params = new URLSearchParams();
    params.set("gold_history_day", selectedDay);
    params.set("gold_history_month", selectedMonth);
    params.set("gold_history_year", selectedYear);
    window.location.href = `/history?${params.toString()}`;
  };

  return (
    <div className="w-full md:w-1/4 px-6 h-fit" id="column-3">
      <div>
        <div>
          <section className="portlet">
            <div className="portlet-content">
              <h2 className="hidden">PNJ Search Form Gold Price Portlet</h2>
              <div className="portlet-content-container">
                <div className="portlet-body">
                  <form>
                    {/* Search form header */}
                    <div className="bg-[#193a66] text-white text-center font-bold md:mb-[5px] text-[12px] leading-[40px]">
                      Lịch sử giá vàng PNJ
                    </div>

                    {/* Day selection */}
                    <div className="mb-6 flex flex-wrap items-center -mx-6">
                      <label
                        className="w-full md:w-1/6 min-h-[1px] text-left md:text-right text-[14px] font-bold px-6 md:pt-[7px] mb-1 md:mb-0"
                        htmlFor="gold_history_day"
                      >
                        Ngày
                      </label>
                      <div className="w-full md:w-5/6 px-6">
                        <select
                          id="gold_history_day"
                          className="block w-full h-[34px] py-[6px] px-[12px] text-[14px] border border-[#ccc] rounded-[4px] shadow-[inset_0_1px_1px_rgba(0, 0, 0, 0.075)]
    focus:border-[#66afe9] focus:outline-none
    focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.075),0_0_8px_rgba(102,175,233,0.6)]
    transition-colors duration-150 ease-in-out"
                          value={selectedDay}
                          onChange={(e) => setSelectedDay(e.target.value)}
                        >
                          {days.map((day) => (
                            <option key={day.value} value={day.value}>
                              {day.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Month selection */}
                    <div className="mb-6 flex flex-wrap items-center -mx-6">
                      <label
                        className="w-full md:w-1/6 min-h-[1px] text-left md:text-right text-[14px] font-bold px-6 md:pt-[7px] mb-1 md:mb-0"
                        htmlFor="gold_history_month"
                      >
                        Tháng
                      </label>
                      <div className="w-full md:w-5/6 px-6">
                        <select
                          id="gold_history_month"
                          className="block w-full h-[34px] py-[6px] px-[12px] text-[14px] border border-[#ccc] rounded-[4px] shadow-[inset_0_1px_1px_rgba(0, 0, 0, 0.075)]
    focus:border-[#66afe9] focus:outline-none
    focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.075),0_0_8px_rgba(102,175,233,0.6)]
    transition-colors duration-150 ease-in-out"
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Year selection */}
                    <div className="mb-6 flex flex-wrap items-center -mx-6">
                      <label
                        className="w-full md:w-1/6 min-h-[1px] text-left md:text-right text-[14px] font-bold px-6 md:pt-[7px] mb-1 md:mb-0"
                        htmlFor="gold_history_year"
                      >
                        Năm
                      </label>
                      <div className="w-full md:w-5/6 px-6">
                        <select
                          id="gold_history_year"
                          className="block w-full h-[34px] py-[6px] px-[12px] text-[14px] border border-[#ccc] rounded-[4px] shadow-[inset_0_1px_1px_rgba(0, 0, 0, 0.075)]
    focus:border-[#66afe9] focus:outline-none
    focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.075),0_0_8px_rgba(102,175,233,0.6)]
    transition-colors duration-150 ease-in-out"
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(e.target.value)}
                        >
                          {years.map((year) => (
                            <option key={year.value} value={year.value}>
                              {year.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Search button */}
                    <div className="flex flex-wrap items-center -mx-6">
                      <div className="md:block md:w-1/6"></div>
                      <div className="w-full md:w-5/6 px-6">
                        <button
                          type="button"
                          className="inline-block px-[12px] py-[6px] text-[14px] font-normal text-gray-800 bg-white border border-[#ccc] rounded-[4px] hover:bg-[#e6e6e6] hover:border-[#adadad] focus:outline-none focus:ring-2 focus:ring-blue-300"
                          onClick={searchGoldPriceHistory}
                        >
                          Tra cứu
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
